import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addClientDirectoryApi,
  addLeadCommentsApi,
  addLeadRecordingApi,
  changeClientStatusApi,
  clientAadharAndPanUniqueCheckApi,
  getCityListApi,
  getClientDirectoryApi,
  getClientLeadListApi,
  getClientMeetUpChecklistApi,
  getClientSortByThresholdLeadListApi,
  getLeadCommentsDetailsApi,
  getLeadEmailHistoryApi,
  getLeadHistoryApi,
  getLeadRecordingsDetailsApi,
  getLeadStageCountApi,
  getLeadStageSortByStageCountApi,
  getSingleClientDirectoryApi,
  getSingleClientLeadDetailsApi,
  getSingleClientMeetUpChecklistApi,
  getStageListApi,
  sendClientEmailApi,
  sendLeadEmailApi,
  updateClientDirectoryApi,
  updateClientLeadDetailsApi,
  updateClientMeetUpCheckListApi,
  updateLeadStageApi,
  updateLeadStatusApi,
} from "@/apis/clientDirectory";

import type {
  AadhaarAndPanUniqueCheckPayloadType,
  AddClientDirectoryPayloadType,
  AddLeadModuleCommentPayload,
  ChangeClientStatusChangePayloadType,
  EmailHistoryPayload,
  GetCityListPayloadType,
  GetClientDirectoryListPayloadType,
  GetClientMeetUpChecklistPayloadType,
  GetHistoryPayload,
  GetLeadDirectoryListPayloadType,
  GetLeadModuleCommentsPayload,
  GetSingleClientDirectoryPayloadType,
  GetSingleClientMeetUpChecklistPayloadType,
  MeetingChecklistPayload,
  SendEmailPayload,
  SingleClientLeadDirectoryDetails,
  StageInfoPayloadType,
  UpdateClientDirectoryPayloadType,
  UpdateSingleClientLeadDirectoryDetails,
} from "@/commonTypes/clientDirectoryTypes";

export const updateClientDirectoryAction = createAsyncThunk(
  "clientDirectory/updateClientDirectory",
  async (data: UpdateClientDirectoryPayloadType) => {
    const response = await updateClientDirectoryApi(data);
    return response;
  }
);

export const changeClientStatusAction = createAsyncThunk(
  "clientDirectory/changeClientStatus",
  async (data: ChangeClientStatusChangePayloadType) => {
    const response = await changeClientStatusApi(data);
    return response;
  }
);

export const clientAadharUniqueCheckAction = createAsyncThunk(
  "clientDirectory/clientAadharAndPanUniqueCheck",
  async (data: AadhaarAndPanUniqueCheckPayloadType) => {
    const response = await clientAadharAndPanUniqueCheckApi(data);
    return response?.data;
  }
);
export const clientPanUniqueCheckAction = createAsyncThunk(
  "clientDirectory/clientPanUniqueCheck",
  async (data: AadhaarAndPanUniqueCheckPayloadType) => {
    const response = await clientAadharAndPanUniqueCheckApi(data);
    return response?.data;
  }
);

export const addClientDirectoryAction = createAsyncThunk(
  "clientDirectory/addClientDirectory",
  async (data: AddClientDirectoryPayloadType) => {
    const response = await addClientDirectoryApi(data);
    return response;
  }
);
export const getClientDirectoryListAction = createAsyncThunk(
  "clientDirectory/getClientDirectoryList",
  async (data: GetClientDirectoryListPayloadType) => {
    const response = await getClientDirectoryApi(data);
    return response;
  }
);
export const getSingleClientDirectoryAction = createAsyncThunk(
  "clientDirectory/getSingleClientDirectory",
  async (data: GetSingleClientDirectoryPayloadType) => {
    const response = await getSingleClientDirectoryApi(data);
    return response;
  }
);
// lead
export const getClientDirectoryLeadListAction = createAsyncThunk(
  "teadModule/getClientLeadList",
  async (data: GetLeadDirectoryListPayloadType) => {
    const response = await getClientLeadListApi(data);
    return response;
  }
);

export const getClientDirectorySortByThresholdLeadListAction = createAsyncThunk(
  "teadModule/getClientLeadList/sortByThreshold",
  async (data: GetLeadDirectoryListPayloadType) => {
    const response = await getClientSortByThresholdLeadListApi(data);
    return response;
  }
);

export const getClientDirectoryLeadStageCountAction = createAsyncThunk(
  "leadModule/getClientLeadStageCount",
  async (data: GetLeadDirectoryListPayloadType) => {
    const response = await getLeadStageCountApi(data);
    return response;
  }
);

export const getClientDirectoryLeadStageSortByStageCountAction =
  createAsyncThunk(
    "leadModule/getClientLeadStageCount/sort",
    async (data: GetLeadDirectoryListPayloadType) => {
      const response = await getLeadStageSortByStageCountApi(data);
      return response;
    }
  );

export const getSingleClientDirectoryLeadDetailsAction = createAsyncThunk(
  "teadModule/getSingleClientLeadDetails",
  async (data: SingleClientLeadDirectoryDetails) => {
    const response = await getSingleClientLeadDetailsApi(data);
    return response;
  }
);
export const updateClientDirectoryLeadDetailsAction = createAsyncThunk(
  "teadModule/updateClientLeadDetails",
  async (data: UpdateSingleClientLeadDirectoryDetails) => {
    const response = await updateClientLeadDetailsApi(data);
    return response;
  }
);
//  lead comment
export const getLeadCommentsDetailsAction = createAsyncThunk(
  "leadModule/getLeadComment",
  async (data: GetLeadModuleCommentsPayload) => {
    const response = await getLeadCommentsDetailsApi(data);
    return response.data;
  }
);
//  lead recording
export const getLeadRecordingDetailsAction = createAsyncThunk(
  "leadModule/getLeadRecording",
  async (data: GetLeadModuleCommentsPayload) => {
    const response = await getLeadRecordingsDetailsApi(data);
    return response.data;
  }
);

export const addLeadCommentsAction = createAsyncThunk(
  "leadModule/addLeadComment",
  async (data: AddLeadModuleCommentPayload) => {
    const response = await addLeadCommentsApi(data);
    return response.data;
  }
);
export const addLeadRecordingAction = createAsyncThunk(
  "leadModule/addLeadRecording",
  async (data: AddLeadModuleCommentPayload) => {
    const response = await addLeadRecordingApi(data);
    return response.data;
  }
);

export const leadHistoryAction = createAsyncThunk(
  "leadModule/history",
  async (data: GetHistoryPayload) => {
    const response = await getLeadHistoryApi(data);
    return response.data;
  }
);

export const leadSentEmailAction = createAsyncThunk(
  "leadModule/email",
  async (data: SendEmailPayload) => {
    const response = await sendLeadEmailApi(data);
    return response.data;
  }
);

export const clientSentEmailAction = createAsyncThunk(
  "clientModule/email",
  async (data: SendEmailPayload) => {
    const response = await sendClientEmailApi(data);
    return response.data;
  }
);
export const leadClientSentEmailHistoryAction = createAsyncThunk(
  "leadClientModule/email/history",
  async (data: EmailHistoryPayload) => {
    const response = await getLeadEmailHistoryApi(data);
    return response.data;
  }
);

export const updateClientMeetUpChecklistAction = createAsyncThunk(
  "leadModule/updateClientMeetUpChecklist",
  async (data: MeetingChecklistPayload) => {
    const response = await updateClientMeetUpCheckListApi(data);
    return response;
  }
);

export const getClientMeetUpChecklistAction = createAsyncThunk(
  "clientDirectory/getClientMeetUpChecklistAction",
  async (data: GetClientMeetUpChecklistPayloadType) => {
    const response = await getClientMeetUpChecklistApi(data);
    return response.data;
  }
);

export const getSingleClientMeetUpChecklistAction = createAsyncThunk(
  "clientDirectory/getSingleClientMeetUpChecklistAction",
  async (data: GetSingleClientMeetUpChecklistPayloadType) => {
    const response = await getSingleClientMeetUpChecklistApi(data);
    return response.data;
  }
);

export const getCityListAction = createAsyncThunk(
  "clientDirectory/getCityListAction",
  async (data: GetCityListPayloadType) => {
    const response = await getCityListApi(data);
    return response.data;
  }
);

export const updateLeadStatusAction = createAsyncThunk(
  "clientDirectory/updateLeadStatusAction",
  async (data: ChangeClientStatusChangePayloadType) => {
    const response = await updateLeadStatusApi(data);
    return response.data;
  }
);

export const updateLeadStageAction = createAsyncThunk(
  "clientDirectory/updateLeadStageAction",
  async (data: StageInfoPayloadType) => {
    const response = await updateLeadStageApi(data);
    return response.data;
  }
);

export const getStageListAction = createAsyncThunk(
  "clientDirectory/getStageListAction",
  async (data: GetCityListPayloadType) => {
    const response = await getStageListApi(data);
    return response.data;
  }
);
